module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "galley-rw"
  }, [_c('section', {
    staticClass: "frontmatter-rw preface-rw auto-rw page-open-left-rw",
    attrs: {
      "epub:type": "frontmatter preface",
      "id": "preface003"
    }
  }, [_c('div', {
    staticClass: "sidebar"
  }, [_c('div', {
    staticClass: "ext_ch"
  }, [_c('div', {
    staticClass: "decoration-rw10"
  }, [_c('div', {
    staticClass: "media-rw image-rw float-none-rw floatgalley-none-rw align-center-rw width-fixed-rw exclude-print-rw"
  }, [_c('div', {
    staticClass: "pc-rw"
  }, [_c('img', {
    staticClass: "orn1",
    attrs: {
      "alt": "",
      "src": "images/Art_Pviii.jpg"
    }
  })])])])]), _vm._v(" "), _c('p', {
    staticClass: "space-break"
  }, [_vm._v("When all is said and done, how do we not know but that our own unreason may be better than another’s truth? for it has been warmed on our hearths and in our souls, and is ready for the wild bees of truth to hive in it, and make their sweet honey. Come into the world again, wild bees, wild bees!")]), _vm._v(" "), _c('p', {
    staticClass: "ca"
  }, [_vm._v("—W. B. Yeats, "), _c('em', [_vm._v("The Celtic Twilight: Faerie and Folklore")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-690e8039","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/preface003.vue
// module id = 75
// module chunks = 0